

import React, { useState } from "react";
import Lightbox from "react-image-lightbox";
import "react-image-lightbox/style.css"; // ✅ important: include CSS


const Slidsmooth = () => {
  const images = [
    // "BS1.jpg", "BS2.JPG","BS3.JPEG","BS4.jpg","BS5.jpg","BS6.jpg","BS7.jpg","BS8.jpg","BS9.jpg","BS10.jpg","BS11.jpg","BS12.jpg","BS13.jpg","BS14.jpg","BS15.JPG","BS16.jpg","BS17.JPG","BS18.jpg","BS19.jpg","BS20.jpg","BS21.jpg",
    "BS1.jpg", "BS2.jpg", "BS3.jpeg", "BS4.jpg", "BS5.jpg", "BS6.jpg", "BS7.jpg", "BS8.jpg", "BS9.jpg", "BS10.jpg", "BS11.jpg", "BS12.jpg", "BS13.jpg", "BS14.jpg", "BS15.jpg", "BS16.jpg", "BS17.jpg", "BS18.jpg", "BS19.jpg", "BS20.jpg", "BS21.jpg",
  ];

  const doubledImages = [...images, ...images];

  const [isOpen, setIsOpen] = useState(false);
  const [photoIndex, setPhotoIndex] = useState(0);

  return (
    <div className="slidsmooth-container">
      <div className="category-main">
        <div className="category-text">
          <p className="category-one">Featured Collection</p>
        </div>
      </div>

      <div className="slidsmooth-wrapper">
        <div className="slidsmooth-slider">
          {doubledImages.map((img, index) => (
            <div
              className="slidsmooth-slide"
              key={index}
              onClick={() => {
                setPhotoIndex(index);
                setIsOpen(true);
              }}
            >
              {/* <img src={`assets/img/Bestselling/${img}`} alt={`slide-${index}`} /> */}
              <img
                src={`/assets/img/Bestselling/${img}`}
                alt={`slide-${index}`}
                //loading="eager"
               loading="lazy"
                // decoding="sync"
                decoding="async"
              />
            </div>
          ))}
        </div>
      </div>

      {isOpen && (
        <Lightbox
          mainSrc={`/assets/img/Bestselling/${doubledImages[photoIndex]}`}
          nextSrc={`/assets/img/Bestselling/${doubledImages[(photoIndex + 1) % doubledImages.length]}`}
          prevSrc={`/assets/img/Bestselling/${doubledImages[(photoIndex + doubledImages.length - 1) % doubledImages.length]}`}
          onCloseRequest={() => setIsOpen(false)}
          onMovePrevRequest={() =>
            setPhotoIndex((photoIndex + doubledImages.length - 1) % doubledImages.length)
          }
          onMoveNextRequest={() =>
            setPhotoIndex((photoIndex + 1) % doubledImages.length)
          }
        />
      )}
    </div>
  );
};

export default Slidsmooth;
